import Evaluate from "./evaluate";

export default Evaluate;